(() => {
 if (window.usfCollectionFilms) return;
 window.usfCollectionFilms = true;
 const motion = matchMedia('(prefers-reduced-motion: reduce)');
 const boxes = new Set();
 const load = video => { if (!video.getAttribute('src') && video.dataset.filmSrc) { video.src = video.dataset.filmSrc; video.load(); } };
 const update = box => { const video = box.querySelector('video'); if (box.dataset.filmVisible === 'true' && !document.hidden && !motion.matches && !box.dataset.userPaused) { load(video); video.play().catch(() => {}); } else video.pause(); };
 const observer = new IntersectionObserver(entries => entries.forEach(entry => { entry.target.dataset.filmVisible = String(entry.isIntersecting); update(entry.target); }), { threshold: 0.15 });
 function init(scope) {
  scope.querySelectorAll('[data-collection-film]').forEach(box => {
   if (box.dataset.filmReady) return;
   const video = box.querySelector('video'), button = box.querySelector('[data-film-toggle]');
   if (!video || !button) return;
   box.dataset.filmReady = 'true'; boxes.add(box);
   const sync = () => { const label = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel; button.textContent = label; button.setAttribute('aria-label', label + ': ' + (box.dataset.filmTitle || 'Collection')); };
   video.addEventListener('play', sync); video.addEventListener('pause', sync);
   video.addEventListener('error', () => { button.hidden = true; });
   button.addEventListener('click', () => { if (video.paused) { delete box.dataset.userPaused; load(video); video.play().catch(() => {}); } else { box.dataset.userPaused = 'true'; video.pause(); } });
   sync(); observer.observe(box);
  });
 }
 init(document);
 document.addEventListener('shopify:section:load', event => init(event.target));
 document.addEventListener('shopify:section:unload', event => { for (const box of boxes) if(event.target.contains(box)){ observer.unobserve(box); boxes.delete(box); } });
 document.addEventListener('visibilitychange', () => boxes.forEach(update));
 motion.addEventListener('change', () => boxes.forEach(update));
})();